<!-- eslint-disable vue/singleline-html-element-content-newline -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <v-menu
    :close-on-content-click="false"
    content-class="list-style"
  >
    <template #activator="{ on: filterOn, attrs: filterAttrs }">
      <v-btn
        icon
        :ripple="false"
        v-bind="filterAttrs"
        v-on="filterOn"
      >
        <v-icon>{{ icons.mdiFilterVariant }}</v-icon>
      </v-btn>
    </template>
    <template #default>
      <v-list two-line>
        <v-subheader>絞り込み</v-subheader>
        <v-list-item>
          <v-select
            v-model="filters.primary"
            :items="uniquePrimaryLabels"
            label="主分類"
            clearable
            dense
            hide-details
            :no-data-text="'データがありません'"
          />
        </v-list-item>
        <v-list-item>
          <v-select
            v-model="filters.secondary"
            :items="filteredSecondaryLabels"
            label="副分類"
            clearable
            dense
            hide-details
            :no-data-text="filters.primary ? 'データがありません' : '主分類を選択してください'"
          />
        </v-list-item>
        <template v-if="showTertiaryColumns">
          <v-list-item>
            <v-select
              v-model="filters.tertiary"
              :items="filteredTertiaryLabels"
              label="第三分類"
              clearable
              dense
              hide-details
              :no-data-text="filters.secondary ? 'データがありません' : '副分類を選択してください'"
            />
          </v-list-item>
          <v-list-item>
            <v-select
              v-model="filters.quaternary"
              :items="filteredQuaternaryLabels"
              label="第四分類"
              clearable
              dense
              hide-details
              :no-data-text="filters.tertiary ? 'データがありません' : '第三分類を選択してください'"
            />
          </v-list-item>
        </template>
      </v-list>
    </template>
  </v-menu>
</template>

<script>
import { mdiFilterVariant } from '@mdi/js'

export default {
  props: {
    filters: {
      type: Object,
      required: true,
    },
    uniquePrimaryLabels: {
      type: Array,
      required: true,
    },
    filteredSecondaryLabels: {
      type: Array,
      required: true,
    },
    filteredTertiaryLabels: {
      type: Array,
      required: true,
    },
    filteredQuaternaryLabels: {
      type: Array,
      required: true,
    },
    showTertiaryColumns: {
      type: Boolean,
      required: true,
    },
  },

  data: () => ({
    icons: {
      mdiFilterVariant,
    },
  }),
}
</script>
